import { useState } from "react";
import { useModalStore } from "../../../stores/modalStore";

export function LeaveServerModal() {
  const { type, isOpen, onClose, data } = useModalStore();
  const [isLoading, setIsLoading] = useState(false);

  const isModalOpen = isOpen && type === "leaveServer";
  const { server } = data || {};

  const handleLeave = async () => {
    try {
      setIsLoading(true);
      // TODO: Call API to leave server
      console.log("Leaving server...", server);
      setTimeout(() => {
        setIsLoading(false);
        onClose();
      }, 1000);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  if (!isModalOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg w-full max-w-md p-6">
        <h2 className="text-2xl font-bold text-center mb-2">Leave Server</h2>
        <p className="text-center text-zinc-500 dark:text-zinc-400 mb-6">
          Are you sure you want to leave{" "}
          <span className="font-semibold text-indigo-500">{server?.name}</span>?
        </p>
        <div className="flex justify-between gap-4">
          <button
            onClick={onClose}
            disabled={isLoading}
            className="flex-1 px-4 py-2 bg-gray-200 dark:bg-gray-700 rounded hover:bg-gray-300 dark:hover:bg-gray-600 transition"
          >
            Cancel
          </button>
          <button
            onClick={handleLeave}
            disabled={isLoading}
            className="flex-1 px-4 py-2 bg-indigo-500 hover:bg-indigo-600 text-white rounded transition"
          >
            {isLoading ? "Leaving..." : "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
}
